export const getPlatform = () => {
  const ua = navigator.userAgent;
  const isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

  const isOtherBrowserOnIOS = /crios|fxios|edgios|opios/i.test(ua);

  const isSafariBrowser = /safari/i.test(ua) && !isOtherBrowserOnIOS && !/chrome|chromium|android/i.test(ua);

  return { isMacOs, isSafariBrowser };
};
